import { useMemoizedFn } from 'ahooks'
import { useRouter as useNextRouter } from 'next/router'

import { normalizeLinkHref, normalizeLinkHrefProps } from './_helpers'
import { useLinkContext } from './LinkContext/hooks'

import type { LinkProps } from 'next/link'

import { useResolvedHostname } from '@/hooks/routes'


import { useUrl } from '@/hooks/routes';
export interface IGetHrefPropsOptions
  extends Pick<LinkProps, 'href' | 'as' | 'locale'> {
  /**
   * 自定义 origin，形如 https://foo.com
   *
   * 用于覆写相对路径的 origin 方便子站与主站间的相互跳转
   *
   * 值得注意的是，如果想在外部已使用 LinkContextProvider 时再次翻转使用当前页面的 origin 可将该值设为 `false`，此时组件不再使用 LinkContextProvider 提供的值。
   * 而是直接使用当前页面的 origin。
   */
  prefixOrigin?: string | false
}

export function useGetHrefProps() {
  const { locale: currentLocale, defaultLocale } = useNextRouter()
  const { prefixOrigin: contextPrefixOrigin } = useLinkContext()
  const url = useUrl()
  const resolvedHost = useResolvedHostname()

  const getHrefProps = useMemoizedFn((options: IGetHrefPropsOptions) => {
    const { href, as, locale, prefixOrigin } = options

    const linkPrefixOrigin =
      prefixOrigin === false ? undefined : prefixOrigin || contextPrefixOrigin

    const hrefUrlObject = normalizeLinkHref(href, url.origin)
    const hrefProps = normalizeLinkHrefProps(hrefUrlObject, {
      resolvedHost,
      href,
      as,
      prefixOrigin: linkPrefixOrigin,
      locale: locale || currentLocale,
      defaultLocale,
    })

    return {
      hrefProps,
      hrefUrlObject,
    }
  })

  return getHrefProps
}
